// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-ConfirmSubmitModal-__ConfirmSubmitModal___2mD18","modal-dialog":"app-pages-Inventory-Adjustment-AdjustmentDetail-AdjustmentForm-ConfirmSubmitModal-__ConfirmSubmitModal___3rp6u"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Adjustment/AdjustmentDetail/AdjustmentForm/ConfirmSubmitModal/ConfirmSubmitModal.css
// module id = 2374
// module chunks = 0